import { Units } from "../Units";

export function All() {
  return <Units title="All" />;
}
